import { useLocation, useNavigate } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Signup from "../Signup/Signup";
import { routes } from "../../utils/constants/routes";
import SignIn from "../signin/SignIn";
import React from "react";
import ResetPassword from "../ResetPassword/ResetPassword";
import SendResetPasswordEmail from "./ResetPassword/SendResetPasswordEmail";

const AuthLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if(location?.pathname !== routes?.authSignin && location?.pathname !== routes?.authSignup && 
      location?.pathname !== routes?.resetPassword) {
      navigate(routes.authSignin);
    }
  }, [location]);

  return (
    <Box bgcolor={"#f5f5f5"}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "2rem"
      }}
    >
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: "100vh",
          width: "90vw",
          maxWidth: "1920px",
          margin: "0 auto",
          gap: "2rem"
        }}
      >
        <Header />
        {location?.pathname === routes.authSignup ? (
          <Signup />
        ) : location?.pathname === routes.authSignin ? (
          <SignIn />
        ) : null
        }
      </Grid>
      <Footer />
    </Box>
  );
};

export default AuthLayout;
